export enum ESprintenTeam {
  Anglamark = 'anglamark',
  CoopMega = 'coop_mega',
  CoopPrix = 'coop_prix',
  Extra = 'extra',
  OBS = 'obs',
}

export const SprintenTeamsLogoMap: Record<string, string> = {
  [ESprintenTeam.Anglamark]: 'assets/team/anglamark.svg',
  [ESprintenTeam.CoopMega]: 'assets/team/coop-mega.svg',
  [ESprintenTeam.CoopPrix]: 'assets/team/coop-prix.svg',
  [ESprintenTeam.Extra]: 'assets/team/coop-extra.svg',
  [ESprintenTeam.OBS]: 'assets/team/coop-obs.svg',
}

export const SprintenTeamsNameMap: Record<string, string> = {
  [ESprintenTeam.Anglamark]: 'Änglamark',
  [ESprintenTeam.CoopMega]: 'Coop Mega',
  [ESprintenTeam.CoopPrix]: 'Coop Prix',
  [ESprintenTeam.Extra]: 'Coop Extra',
  [ESprintenTeam.OBS]: 'OBS',
}
